import { render, staticRenderFns } from "./VBottomNav.vue?vue&type=template&id=0c669815&flat=true"
import script from "./VBottomNav.vue?vue&type=script&lang=js"
export * from "./VBottomNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports